export { hasMarketIntelligencePlan } from "./entitlements";

export const MARKET_INTELLIGENCE_PACKAGE_IDS = [200, 300];

/** Welcome brand metrics that require Market / Full Intelligence (external web + social). */
export const MARKET_INTELLIGENCE_GATED_WELCOME_METRIC_IDS = new Set([18]);

export function welcomeMetricRequiresMarketIntelligencePlan(metricId) {
  return MARKET_INTELLIGENCE_GATED_WELCOME_METRIC_IDS.has(Number(metricId));
}
